import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { Footer, Header, PageWrapper } from '~/components/layout';
import { useUserEvents } from '~/hooks/useUserEvents';

const Layout = () => {
  useUserEvents();

  return (
    <LayoutColumn>
      <Header />
      <PageWrapper>
        <Outlet />
      </PageWrapper>
      <Footer />
    </LayoutColumn>
  );
};

export default Layout;

const LayoutColumn = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  '& main': {
    flex: 1,
  },
}));
